import { render, staticRenderFns } from "./AthleteVerifiedAssessmentSummary.vue?vue&type=template&id=049ad4e0&"
import script from "./AthleteVerifiedAssessmentSummary.vue?vue&type=script&lang=ts&"
export * from "./AthleteVerifiedAssessmentSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports